export default __webpack_public_path__ + "static/media/android-icon-off.5731b48a.svg";